// src/propertyManagement/pages/Leases.jsx
import React from 'react';
import useLandlordData from '../hooks/useLandlordData';

export default function Leases() {
  const { leases, loading, error } = useLandlordData();

  if (loading) return <p style={styles.message}>Loading leases…</p>;
  if (error)   return <p style={styles.message}>Error loading leases.</p>;

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Leasing</h1>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Tenant</th>
            <th style={styles.th}>Property</th>
            <th style={styles.th}>Start Date</th>
            <th style={styles.th}>End Date</th>
            <th style={styles.th}>Status</th>
          </tr>
        </thead>
        <tbody>
          {leases.map((l) => (
            <tr key={l.id}>
              <td style={styles.td}>{l.tenantName}</td>
              <td style={styles.td}>{l.propertyAddress}</td>
              <td style={styles.td}>{new Date(l.startDate).toLocaleDateString()}</td>
              <td style={styles.td}>{new Date(l.endDate).toLocaleDateString()}</td>
              <td style={styles.td}>{l.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    background: '#fff',
    borderRadius: 4,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  },
  heading: {
    fontSize: '1.5rem',
    marginBottom: '1rem'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  th: {
    textAlign: 'left',
    borderBottom: '2px solid #eee',
    padding: '0.5rem'
  },
  td: {
    padding: '0.5rem',
    borderBottom: '1px solid #f0f0f0'
  },
  message: {
    padding: '2rem',
    textAlign: 'center',
    color: '#777'
  }
};